// extracted by mini-css-extract-plugin
export default {"details":"Details_details__qDPT2","detailsLeft":"Details_detailsLeft__rxYo5","detailsRight":"Details_detailsRight__8cMUz"};